import api from "../config/api";

export const saveBill = async (payload) => {
  try {
    const res = await api.post("/bill/", payload);
    return res.data;
  } catch (err) {
    throw err.response?.data || err;
  }
};

export const getAllBills = async () => {
  try {
    const res = await api.get("/bill/");
    return res.data; // returns array
  } catch (err) {
    throw err.response?.data || err;
  }
};

export const getBillById = async (id) => {
  try {
    const res = await api.get(`/bill/?id=${id}`);
    return res.data; // { data:{bill,trips}, code }
  } catch (err) {
    throw err.response?.data || err;
  }
};

export const getBillsByFilter = async ({
  date = "",
  vendor_id = 0,
  vehicle_id = 0,
  status = "",
}) => {
  try {
    const params = new URLSearchParams();
    if (date) params.append("date", date);
    if (vendor_id) params.append("vendor_id", vendor_id);
    if (vehicle_id) params.append("vehicle_id", vehicle_id);
    if (status) params.append("status", status);

    const res = await api.get(`/bill/?${params.toString()}`);
    return res.data; // { data:{bill,trips} }
  } catch (err) {
    throw err.response?.data || err;
  }
};

export const deleteBill = async (id) => {
  try {
    const res = await api.delete(`/bill/?id=${id}`);
    return res.data;
  } catch (err) {
    throw err.response?.data || err;
  }
};

export const getAllBillsPaginated = (page = 1, limit = 10, status) => {
  return api.get("/bill/", {
    params: {
      page,
      limit,
      status,
    },
  });
};
